<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>资源管理
      <i class="el-icon-arrow-right"></i>&nbsp;用量统计
    </div>

    <br>
    <div class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-form :inline="true" label-width="120px">
        <div class="item-wrapper">

          <div class="item-content clearfix">
            <el-form-item label="产品名称" style="margin-bottom: 0px;">
              <el-select v-model="product" placeholder="请选择">
                <el-option
                  v-for="item in products"
                  :key="item.productKey"
                  :label="item.productName"
                  :value="item.productKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="日期">
              <el-date-picker
                v-model="queryTime"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                :editable='false'
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleQuery">查 询</el-button>
            </el-form-item>
          </div>

        </div>
      </el-form>
    </div>

    <section style="margin-top: 10px; margin-left: 20px;">
      <EChart :options="chartOptions"></EChart>
    </section>

  </main>
</template>

<style>
.el-table .success-cell {
  background: #F0F9EB;
  font-weight: bold;
}
</style>

<script>
import EChart from '@/components/EChart.vue'
import {mapState} from 'vuex'
import {
  dateFormatter
} from '@/common/utils.js'

import {
  reqProductInfo,
  reqStatistics
} from '@/api'

export default {
  name: 'Statistics',
  components: {EChart},

  data() {
    return {
      products: [],
      product: '',

      chartOptions: {
        title: {
          text: '调用量统计（单位：Token）'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['全部', '输入Token', '输出Token']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '全部',
            type: 'line',
            data: [],
            smooth: true
          },
          {
            name: '输入Token',
            type: 'line',
            data: [],
            smooth: true
          },
          {
            name: '输出Token',
            type: 'line',
            data: [],
            smooth: true
          }
        ]
      },

      tableData: {},
      loading: true,
      queryTime: [],
      startData: '',
      endData: '',
      currentPage: 1,
      total: 0,
      pageSize: 30,
      firstQuery: true,

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },

  async mounted() {
    let start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    const end = new Date()
    this.queryTime.push(dateFormatter(start))
    this.queryTime.push(dateFormatter(end))

    const loading = this.$loading({
      lock: true,
      text: '查询中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    await this.getProduct()

    if (this.product) {
      await this.getStatistics()
    } else {
      this.$message({
        message: '当前没有产品信息',
        type: 'warning'
      })
    }

    loading.close()
    this.firstQuery = false
  },

  methods: {
    async getProduct() {
      const result = await reqProductInfo('/product/getProductList', this.currentPage, this.pageSize)

      if (result.code === 200) {
        // result.data.data.forEach(e => this.products.push(e.productKey))
        // this.products = result.data.data.map(function(element) {
        //   return element.productKey
        // })

        if (result.data.total > 0) {
          this.products = result.data.data.map(function(element) {
            return {"productKey": element.productKey, "productName": element.productName}
          })
          this.product = this.products[0].productKey
        }

      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async getStatistics() {
      let loading
      if (!this.firstQuery) {
        loading = this.$loading({
          lock: true,
          text: '查询中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      this.startData = this.queryTime[0] + " 00:01:01"
      this.endData = this.queryTime[1] + " 23:59:59"
      const result = await reqStatistics('/token_usage/queryTokenUsage', this.product, this.startData, this.endData)
      if (!this.firstQuery) {
        loading.close()
      }

      if (result.code === 200) {
        const category = Object.keys(result.data)
        const values = Object.values(result.data)

        let inToken = []
        let outToken = []
        let totalToken = []
        values.forEach(function(e) {
          inToken.push(e.inputToken)
          outToken.push(e.outputToken)
          totalToken.push(e.inputToken + e.outputToken)
        })

        this.chartOptions.xAxis.data = category
        this.chartOptions.series[0].data = totalToken
        this.chartOptions.series[1].data = inToken
        this.chartOptions.series[2].data = outToken
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }

      // const result = await reqStatistics()
      // if (result.code === 0) {
      //   this.chartOptions.xAxis.data = result.data.category
      //   this.chartOptions.series[0].data = result.data.totalToken
      //   this.chartOptions.series[1].data = result.data.inToken
      //   this.chartOptions.series[2].data = result.data.outToken
      //
      //   this.tableData = result
      //   this.loading = false
      // } else {
      //   this.$message.error('数据查询失败，错误信息: ' + result.message)
      // }
    },

    handleQuery () {
      this.getStatistics()
    }
  },

  computed: {
    ...mapState(['navCollapse', 'wrapperWidth']),
  }

}
</script>

<style scoped>

main {
  display: flex;
  flex-direction: column;
}

.query_wrapper {
  width: 82vw;
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin: 20px auto;
}

.content_wrapper {
  width: 82vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/Statistics/Statistics.vue